export enum PropostaProviders {
  mapfre = "mapfre",
  porto = "porto",
  sancor = "sancor",
  sompo = "sompo",
  swissre = "swissre",
  btg = "btg",
  allianz = "allianz",
  essor = "essor",
  fairfax = "fairfax",
}

export enum BasicCoverageTypes {
  CUSTEIO = "custeio",
  PRODUTIVIDADE = "produtividade",
  RISCO_NOMEADO = "risco nomeado",
}

export type CoverageType = {
  id: string;
  coverageName: string;
  lmi: string;
  prize: string;
};

export type TInsertSimulationDetailsPayload = {
  name: string;
  provider: PropostaProviders | "";
  coverageType: BasicCoverageTypes | "";
  subvencaoFederal: string;
  subvencaoEstadual: string;
  parcelas: string;
  coverage: CoverageType[];
  guaranteedProductivity: string;
};
